export default __webpack_public_path__ + "static/media/iPostal.3ad45150.png";